/* Priva theme — global behaviors

   Handles:
   - Mobile nav toggle
   - Instructions sidebar scroll-spy
   - Global Shopify cart bar (visible site-wide when items exist)
   - AJAX product form submission (PDP add-to-cart without page reload)
*/

(function () {
  // ---------- Mobile menu ----------
  // aria-expanded mirrors .nav.open; Escape closes and returns focus to the toggle.
  (function () {
    const toggle = document.querySelector('.menu-toggle');
    const nav = document.querySelector('.nav');
    if (!toggle || !nav) return;
    function setOpen(open) {
      nav.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('open')));
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !nav.classList.contains('open')) return;
      setOpen(false);
      toggle.focus();
    });
  })();

  // ---------- Instructions / Learn sidebar scroll-spy ----------
  (function () {
    const navLinks = document.querySelectorAll('.instr-nav a');
    if (!navLinks.length) return;
    const sections = Array.from(navLinks).map((a) =>
      document.querySelector(a.getAttribute('href'))
    );
    function onScroll() {
      const y = window.scrollY + 140;
      let active = 0;
      sections.forEach((s, i) => {
        if (s && s.offsetTop <= y) active = i;
      });
      navLinks.forEach((l) => l.classList.remove('active'));
      if (navLinks[active]) navLinks[active].classList.add('active');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ---------- Cart bar (global) ----------
  const $cartBar   = document.getElementById('cartBar');
  const $cartItems = document.getElementById('cartItems');
  const $cartTotal = document.getElementById('cartTotal');
  const emptyLabel = $cartBar?.dataset.emptyLabel || 'Nothing selected yet';

  function money(cents) {
    // Format in the shopper's active currency (Shopify sets Shopify.currency.active),
    // dropping ".00" on whole amounts like the rest of the site.
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  window.Priva = window.Priva || {};

  Priva.fetchCart = function () {
    return fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
  };

  Priva.renderCart = function (cart) {
    // Header cart badge — updated on every page, cart bar or not.
    var count = (cart && cart.item_count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });

    if (!$cartBar) return;
    // When the shop configurator owns the cart bar (a device is being
    // configured), it drives the display itself — don't clobber it.
    if ($cartBar.dataset.configuratorActive === '1') {
      // Still keep standalone accessory steppers in sync with the live cart.
      if (cart && cart.items) {
        var liveMap = {};
        cart.items.forEach(function (item) {
          liveMap[item.variant_id] = (liveMap[item.variant_id] || 0) + item.quantity;
        });
        document.querySelectorAll('[data-accessory]').forEach(function (card) {
          var aid = parseInt(card.dataset.variantId, 10);
          var aqty = liveMap[aid] || 0;
          var disp = card.querySelector('[data-qty-display]');
          if (disp) disp.textContent = aqty;
          card.classList.toggle('selected', aqty > 0);
        });
      }
      return;
    }
    if (!cart || cart.item_count === 0) {
      $cartBar.hidden = true;
      $cartBar.classList.remove('active');
      if ($cartItems) $cartItems.textContent = emptyLabel;
      if ($cartTotal) $cartTotal.textContent = '$0';
      // Reset any stepper UIs on the page
      document.querySelectorAll('[data-qty-display]').forEach((el) => { el.textContent = '0'; });
      document.querySelectorAll('[data-accessory]').forEach((el) => el.classList.remove('selected'));
      return;
    }

    $cartBar.hidden = false;
    requestAnimationFrame(() => $cartBar.classList.add('active'));

    const lines = cart.items.map((item) => {
      const qty = item.quantity > 1 ? `${item.quantity} × ` : '';
      const variantSuffix = (item.variant_title && item.variant_title !== 'Default Title')
        ? ` — ${item.variant_title}` : '';
      return `<span class="cart-line">${qty}${escapeHtml(item.product_title)}${escapeHtml(variantSuffix)}</span>`;
    }).join('');
    if ($cartItems) $cartItems.innerHTML = lines;
    if ($cartTotal) $cartTotal.textContent = money(cart.total_price);

    // Keep accessory steppers in sync
    const map = {};
    cart.items.forEach((item) => {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    document.querySelectorAll('[data-accessory]').forEach((card) => {
      const id = parseInt(card.dataset.variantId, 10);
      const qty = map[id] || 0;
      const display = card.querySelector('[data-qty-display]');
      if (display) display.textContent = qty;
      card.classList.toggle('selected', qty > 0);
    });
  };

  // Initial render
  Priva.fetchCart().then(Priva.renderCart).catch((err) => {
    console.warn('Could not load cart on init', err);
  });

  // ---------- AJAX product form (PDP) ----------
  // Any form.pdp-form intercepts and adds via /cart/add.js
  document.querySelectorAll('form.pdp-form').forEach((form) => {
    const button = form.querySelector('button[type=submit]');
    const originalLabel = button ? button.textContent : '';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: data
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to cart.');
        }
        // Re-fetch cart and update the cart bar
        const cart = await Priva.fetchCart();
        Priva.renderCart(cart);
        if (button) {
          button.textContent = '✓ Added';
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalLabel;
          }, 1400);
        }
      } catch (err) {
        console.error('Add-to-cart failed', err);
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
        alert(err.message || 'Could not add to cart. Please try again.');
      }
    });
  });

  // ---------- Cart page (instant quantity steppers) ----------
  (function () {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;

    function changeLine(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then((r) => r.json());
    }

    // Patch the existing rows in place — never rebuild innerHTML, so the
    // product images are not torn down and re-fetched (which caused the
    // flash). Only the quantity, line price and total text change.
    function patchRows(cart, removedRow) {
      if (!cart || cart.item_count === 0) {
        page.innerHTML =
          '<p>Your cart is empty. <a href="/" style="border-bottom:1px solid currentColor;">Continue shopping &rarr;</a></p>';
        return;
      }
      if (removedRow) removedRow.remove();
      const tbody = page.querySelector('[data-cart-rows]');
      if (tbody) {
        const rows = Array.prototype.slice.call(tbody.querySelectorAll('tr[data-line]'));
        rows.forEach((row, i) => {
          const item = cart.items[i];
          if (!item) { row.remove(); return; }
          row.dataset.line = i + 1;
          const disp = row.querySelector('[data-qty-display]');
          if (disp) disp.textContent = item.quantity;
          const price = row.querySelector('[data-line-price]');
          if (price) price.textContent = money(item.final_line_price);
        });
      }
      const total = page.querySelector('[data-cart-total]');
      if (total) total.textContent = money(cart.total_price);
    }

    // Debounced commit per row — rapid clicks only fire one request with
    // the final quantity, so the cart stays snappy.
    function commit(row) {
      if (row._cartTimer) clearTimeout(row._cartTimer);
      row._cartTimer = setTimeout(async () => {
        row._cartTimer = null;
        const display = row.querySelector('[data-qty-display]');
        const qty = parseInt(display.textContent, 10) || 0;
        row.classList.add('cart-row-busy');
        try {
          const cart = await changeLine(parseInt(row.dataset.line, 10), qty);
          patchRows(cart, qty === 0 ? row : null);
          if (qty !== 0) row.classList.remove('cart-row-busy');
          Priva.renderCart(cart);
        } catch (err) {
          console.error('Cart update failed', err);
          row.classList.remove('cart-row-busy');
          alert('Sorry, could not update the cart. Please try again.');
        }
      }, 320);
    }

    page.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cart-delta]');
      if (!btn) return;
      e.preventDefault();
      const row = btn.closest('tr[data-line]');
      if (!row) return;
      const display = row.querySelector('[data-qty-display]');
      const current = parseInt(display.textContent, 10) || 0;
      const next = Math.max(0, current + parseInt(btn.dataset.cartDelta, 10));
      if (next === current) return;
      // Optimistic: update the number instantly, then commit (debounced).
      display.textContent = next;
      commit(row);
    });
  })();
})();
